import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";

type Input = { step?: string };
type Output = { passed?: number; failed?: number };

function RunStepTestsHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input as Input | null;
  const output = result?.output as Output | undefined;
  const done = !!result && !result.isError;
  const step = input?.step;
  const passed = output?.passed;
  const failed = output?.failed;
  const haveCounts = typeof passed === "number" && typeof failed === "number";

  const text = !done
    ? `Running step tests${step ? ` for ${step}` : ""}…`
    : haveCounts
      ? `${passed} passed, ${failed} failed`
      : `Ran step tests${step ? ` for ${step}` : ""}`;

  return (
    <ToolStatus icon="list-todo" text={text} pending={!done && !interrupted} />
  );
}

export const runStepTests: ChatTool = {
  name: "runStepTests",
  Header: RunStepTestsHeader,
};
